


const PageFour = () => {
  return (
    <>
      <p className="text-xl text-foreground">Telegram is your gateway</p>
      <p className="text-xl text-foreground">/verify, /challenge, /ritual, /complete — shape your future.</p>
      
      <p className="text-xl mt-4 text-foreground">Wagers are sacred. Accept only what you intend to finish.</p>
      <p className="text-xl text-foreground">Submit proof. The community votes. The chain remembers.</p>
      
      <div className="flex items-center space-x-4 pt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">Donations = BroScore bonus + lottery entry.</p>
      </div>
      
      <div className="flex items-center space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">You give. You grow.</p>
      </div>
    </>
  );
};

export default PageFour;
